'use client';

import type { ComponentPropsWithoutRef, ElementType } from 'react';
import { useInView } from '@/hooks/use-in-view';
import { cn } from '@/lib/cn';

type RevealTag = 'div' | 'p' | 'ul' | 'ol' | 'li' | 'span' | 'article' | 'dl';

type RevealProps = ComponentPropsWithoutRef<'div'> & {
  as?: RevealTag;
  delay?: number;
};

export function Reveal({ as = 'div', delay = 0, className, style, ...props }: RevealProps) {
  const { ref, inView } = useInView<HTMLElement>();
  const Tag = as as ElementType;

  return (
    <Tag
      ref={ref}
      data-shown={inView || undefined}
      style={{ transitionDelay: `${delay}ms`, ...style }}
      className={cn(
        'translate-y-5 opacity-0 transition-[opacity,transform] duration-700 ease-soft',
        'data-shown:translate-y-0 data-shown:opacity-100',
        'motion-reduce:translate-y-0 motion-reduce:opacity-100',
        className,
      )}
      {...props}
    />
  );
}
